import React from "react"

export default function Page404() {
  return (
    <div className="container center-align white-text">
      <h1>404</h1>
      <p>Page wasn't found.</p>
    </div>
  )
}
